// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export default class BottomBarEnum {
    static BOTTOMBAR = '[data-element="iris-bottom-bar-sticky"]'
}
